export function hasKey(value: object, key: string): value is Record<string, unknown> {
    return Object.hasOwn(value, key);
}
